import { EntityActionTypeSelectOptionValue } from '../../Entity'

export const QA_NAME_EDIT_PRIORITY_MODAL = 'editPriority'

export const TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME = 'priority_id'

export const TASK_EDIT_PRIORITY_FIELDS_INITIAL_VALUES = {
  [TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME]: null,
}

export const TASK_EDIT_PRIORITY_FORM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]
